import {RequestAxios} from "../../index";
import {ClubsList} from "./interfaces";
import {API_START} from "../../constants";

export const getClubsList = async (city: string) => {
    const clubsUrl = `${API_START}/store_chains/2/stores?locality_name=${city}`;
    return await RequestAxios.get<ClubsList[]>(clubsUrl)
}